/**
 * Cart Progress - Free Gift & Free Shipping
 * Handles auto-add/remove of gift and real-time progress updates
 * Integrates with Dawn's AJAX cart behavior
 */
(function () {
    const giftVariantIdAttr = 'data-gift-variant-id';
    const giftThresholdAttr = 'data-gift-threshold';
    const shippingThresholdAttr = 'data-shipping-threshold';
    const CART_UPDATE_EVENT = (typeof window.PUB_SUB_EVENTS !== 'undefined' && window.PUB_SUB_EVENTS.cartUpdate) || 'cart-update';
  
    function getProgressConfig() {
      const progress = document.querySelector('.cart-progress');
      if (progress) {
        const variantId = progress.getAttribute(giftVariantIdAttr);
        const enableFreeGift = progress.getAttribute('data-enable-free-gift');
        const enableFreeGiftActive = enableFreeGift === null || enableFreeGift === 'true';
        if (variantId || enableFreeGiftActive) {
          return {
            element: progress,
            giftVariantId: variantId ? String(variantId).trim() : '',
            giftThreshold: parseInt(progress.getAttribute(giftThresholdAttr), 10) || 6000,
            shippingThreshold: parseInt(progress.getAttribute(shippingThresholdAttr), 10) || 8000,
            enableFreeGift: enableFreeGiftActive,
          };
        }
      }
      const configEl = document.getElementById('cart-progress-config');
      if (configEl) {
        try {
          const c = JSON.parse(configEl.textContent);
          if (c && (c.giftVariantId || c.enableFreeShipping)) {
            return {
              element: null,
              giftVariantId: c.giftVariantId ? String(c.giftVariantId) : '',
              giftThreshold: c.giftThreshold || 6000,
              shippingThreshold: c.shippingThreshold || 8000,
              enableFreeGift: c.enableFreeGift !== false,
            };
          }
        } catch (_) {}
      }
      return null;
    }
  
    function getQualifyingTotal(cartItems, giftVariantId) {
      const idStr = String(giftVariantId);
      let total = 0;
      for (let i = 0; i < cartItems.length; i++) {
        if (String(cartItems[i].variant_id) !== idStr) {
          total += cartItems[i].final_line_price || cartItems[i].line_price;
        }
      }
      return total;
    }
  
    function hasGiftInCart(cartItems, giftVariantId) {
      const idStr = String(giftVariantId);
      for (let i = 0; i < cartItems.length; i++) {
        if (String(cartItems[i].variant_id) === idStr) return true;
      }
      return false;
    }
  
    function getGiftLineNumber(cartItems, giftVariantId) {
      const idStr = String(giftVariantId);
      for (let i = 0; i < cartItems.length; i++) {
        if (String(cartItems[i].variant_id) === idStr) return i + 1;
      }
      return 0;
    }
  
    function fetchConfig() {
      return typeof window.fetchConfig === 'function'
        ? window.fetchConfig('json')
        : {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          };
    }
  
    function updateDomFromSections(sections) {
      if (!sections) return;
  
      const cartDrawer = document.querySelector('cart-drawer');
      const cartDrawerEl = document.getElementById('CartDrawer');
      const cartIconSection = document.getElementById('cart-icon-bubble');
  
      if (sections['cart-drawer'] && cartDrawerEl) {
        try {
          const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          const newCartDrawer = doc.querySelector('#CartDrawer');
          if (newCartDrawer) {
            cartDrawerEl.innerHTML = newCartDrawer.innerHTML;
            const isEmpty = doc.querySelector('cart-drawer-items.is-empty') || doc.querySelector('.drawer__inner-empty');
            if (cartDrawer) {
              cartDrawer.classList.toggle('is-empty', !!isEmpty);
            }
          }
        } catch (_) {}
      }
  
      if (sections['cart-icon-bubble'] && cartIconSection) {
        try {
          const doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          const newSection = doc.querySelector('.shopify-section') || doc.body.firstElementChild;
          if (newSection) {
            cartIconSection.innerHTML = newSection.innerHTML;
          }
        } catch (_) {}
      }
    }
  
    function handleGiftAddRemove(cartData) {
      const config = getProgressConfig();
      if (!config || !config.enableFreeGift || !config.giftVariantId) return;

      const items = cartData.items || [];
      const qualifyingTotal = getQualifyingTotal(items, config.giftVariantId);
      const hasGift = hasGiftInCart(items, config.giftVariantId);
      const routes = window.routes || {};
      const addBase = routes.cart_add_url || '/cart/add';
      const cartAddUrl = addBase.endsWith('.js') ? addBase : addBase.replace(/\/?$/, '.js');
      const changeBase = routes.cart_change_url || '/cart/change';
      const cartChangeUrl = changeBase.endsWith('.js') ? changeBase : changeBase.replace(/\/?$/, '.js');
  
      const shouldAdd = qualifyingTotal >= config.giftThreshold && !hasGift;
      const shouldRemove = qualifyingTotal < config.giftThreshold && hasGift;
  
      if (shouldAdd) {
        const variantId = parseInt(config.giftVariantId, 10) || config.giftVariantId;
        fetch(cartAddUrl, {
          ...fetchConfig(),
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname,
          }),
        })
          .then((r) => r.json())
          .then((data) => {
            if (data.status && data.description) return;
            if (data.sections) updateDomFromSections(data.sections);
          })
          .catch(() => {});
      } else if (shouldRemove) {
        const line = getGiftLineNumber(items, config.giftVariantId);
        if (!line) return;
  
        fetch(cartChangeUrl, {
          ...fetchConfig(),
          body: JSON.stringify({
            line,
            quantity: 0,
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname,
          }),
        })
          .then((r) => r.json())
          .then((data) => {
            if (data.status && data.description) return;
            if (data.sections) updateDomFromSections(data.sections);
          })
          .catch(() => {});
      }
    }
  
    window.cartProgressTrigger = function () {
      fetchCart().then((cart) => {
        if (cart && cart.items) handleGiftAddRemove(cart);
      }).catch(() => {});
    };
  
    function getCartDataFromEvent(event) {
      if (event && event.cartData && Array.isArray(event.cartData.items)) {
        return event.cartData;
      }
      return null;
    }
  
    function fetchCart() {
      const routes = window.routes || {};
      const cartUrl = (routes.cart_url || '/cart') + '.js';
      return fetch(cartUrl).then((r) => r.json());
    }
  
    function init() {
      setupGiftDetailsDelegation();

      if (typeof subscribe !== 'function') return;

      subscribe(CART_UPDATE_EVENT, () => {
        setTimeout(function runAfterRender() {
          const config = getProgressConfig();
          if (!config) return;

          fetchCart()
            .then((cart) => {
              if (cart && cart.items) handleGiftAddRemove(cart);
            })
            .catch(() => {});
        }, 150);
      });
    }
  
    function setupGiftDetailsDelegation() {
      if (document.body.dataset.cartProgressGiftDelegation) return;
      document.body.dataset.cartProgressGiftDelegation = '1';
      document.body.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-gift-details-toggle]');
        if (!btn) return;
        e.preventDefault();
        const wasExpanded = btn.getAttribute('aria-expanded') === 'true';
        const isExpanded = !wasExpanded;
        btn.setAttribute('aria-expanded', isExpanded);
        const targetId = btn.getAttribute('aria-controls');
        const target = targetId ? document.getElementById(targetId) : null;
        if (target) {
          target.classList.toggle('cart-progress__gift-details--expanded', isExpanded);
          target.setAttribute('aria-hidden', !isExpanded);
        }
        const btnText = btn.querySelector('.cart-progress__gift-details-btn-text');
        if (btnText) {
          btnText.textContent = isExpanded
            ? (btn.getAttribute('data-expanded-text') || 'Close')
            : (btn.getAttribute('data-collapsed-text') || 'Gift details');
        }
      });
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  